import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api, { setAuthToken } from '@/lib/api';
import { useAuth } from '@/context/AuthContext';
import { readStoredReferral, clearStoredReferral } from '@/lib/referral';
import { Loader2 } from 'lucide-react';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;

    const hash = window.location.hash || '';
    const params = new URLSearchParams(hash.replace(/^#/, ''));
    const session_id = params.get('session_id');
    if (!session_id) {
      navigate('/login', { replace: true });
      return;
    }
    (async () => {
      try {
        const referral_code = readStoredReferral() || undefined;
        const { data } = await api.post('/auth/session', { session_id, referral_code });
        if (data.access_token) setAuthToken(data.access_token);
        setUser(data.user);
        clearStoredReferral();
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/dashboard', { replace: true });
      } catch (e) {
        console.error('Session exchange failed', e);
        navigate('/login', { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-slate-200">
      <Loader2 className="h-10 w-10 animate-spin text-fuchsia-400" />
      <p className="mt-6 font-display text-xl">Welcoming you to the universe…</p>
    </div>
  );
};

export default AuthCallback;
